import React, { useEffect } from "react";
import { filterThemes } from "utils/discovery";
import CategoriesDropdown from "layout/discovery/header/CategoriesDropdown";
import PropTypes from "prop-types";
import ShowPills from "layout/discovery/folder/categories/ShowPills";
import {
  areAllDocumentsIgnored,
  getCheckedNPs,
} from "layout/discovery/helpers";
import { useDispatch } from "react-redux";
import { setShowAll } from "slices/discovery/discoverySlice";

const TableHeader = ({ themes, isSearch, filterView, showAll }) => {
  const dispatch = useDispatch();
  let themeList = filterThemes(themes, showAll, isSearch, filterView);
  themeList = themeList.filter((theme) => !areAllDocumentsIgnored(theme));
  const checkedNPs = getCheckedNPs(themes, isSearch, filterView, showAll);
  const hasCheckedItems = checkedNPs.length !== 0;

  /* If user unchecks all items in "Show Checked" view,
    should automatically return him to "Show All" view
  */
  useEffect(() => {
    if (!showAll && !hasCheckedItems) {
      dispatch(setShowAll(true));
    }
  }, [showAll, hasCheckedItems, dispatch]);

  const getShowingThemesString = () => {
    const themesLength = themeList.filter((theme) => !theme.NounPhrase).length;
    return `Themes (${themesLength.toLocaleString()})`;
  };

  return (
    <>
      <span
        className="categories__header__table_header__categories"
        data-testid="categories-table-header"
      >
        {getShowingThemesString()}
      </span>
      <CategoriesDropdown />
      <ShowPills hasCheckedItems={hasCheckedItems} />
    </>
  );
};

export default TableHeader;

TableHeader.propTypes = {
  themes: PropTypes.arrayOf(
    PropTypes.shape({
      Documents: PropTypes.arrayOf(
        PropTypes.shape({
          Id: PropTypes.number.isRequired,
          Name: PropTypes.string,
          Occurrences: PropTypes.number,
          BackgroundColour: PropTypes.string,
          TextColour: PropTypes.string,
        }).isRequired
      ).isRequired,
      GroupName: PropTypes.string.isRequired,
      Occurrences: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  isSearch: PropTypes.bool.isRequired,
  filterView: PropTypes.bool.isRequired,
  showAll: PropTypes.bool.isRequired,
};
